import cn from 'clsx'
import s from './ProductDetails.module.scss'
import { FC, useState } from 'react'
import { Text, CustomImage, Container, Button } from '@components/ui'

import { Product } from '@commerce/types/product'
// import ProductCard from './ProductCard/ProductCard'
import { LoreThreePage } from '@generated/model/loreThreePage'
import ProductDetail from './ProductDetail'

type ProductDetailsProps = {
  page: LoreThreePage
  roadProduct: Product | undefined
  offRoadProduct: Product | undefined
}

const ProductDetails: FC<ProductDetailsProps> = ({
  page,
  roadProduct,
  offRoadProduct,
}) => {
  const [tab, setTab] = useState(0)

  const updateTab = (index: number) => {
    setTab(index)
  }

  if (page.product_details == null) return null

  return (
    <>
      <Container>
        <section className={s.root}>
          <div className={cn(s.grid)}>
            {page.product_details.map((productDetail, index) => (
              <ProductDetail
                key={`product-detail-${index}-${tab}`}
                productDetail={productDetail}
                roadProduct={roadProduct}
                offRoadProduct={offRoadProduct}
                page={page}
                isCurrent={tab === index}
                updateTab={updateTab}
              />
            ))}
          </div>
        </section>
      </Container>
    </>
  )
}

export default ProductDetails
